// extracted by mini-css-extract-plugin
export default {"zoomModal":"L3-z","image":"M3-z","button":"N3-z","isOverlayShown":"O3-z"};